<template>
    <div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label>领用单号</label>
                </div>
                <div class="form-value">
                    <span>{{stuffAppturnVoucherInfo.no}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建商户</label>
                </div>
                <div class="form-value">
                    <span>{{stuffAppturnVoucherInfo.retailerName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建机构</label>
                </div>
                <div class="form-value">
                    <span>{{stuffAppturnVoucherInfo.comName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>仓库名称</label>
                </div>
                <div class="form-value">
                    <span>{{stuffAppturnVoucherInfo.warehouseName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>领用日期</label>
                </div>
                <div class="form-value">
                    <span>{{stuffAppturnVoucherInfo.theDate}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建时间</label>
                </div>
                <div class="form-value">
                    <span>{{stuffAppturnVoucherInfo.createTime}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建人</label>
                </div>
                <div class="form-value">
                    <span>{{stuffAppturnVoucherInfo.creatorName}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>耗材领用信息</span>
        </div>
        <div class="simple-row">
            <div class="right">
                <span v-if="shopDeviceAppturnItem != null">已选择({{shopDeviceAppturnItem.length}})</span>
            </div>
        </div>
        <swb-query-sort-area name="query-sort-area" ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :onConfigReady="onResultConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        <swb-result-table name="result_table" ref="result_table" :confKey="resultKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { openShopDeviceSuitSelectDlg } from '../ShopDeviceLowCost/selectDlg'
    import { getDevcGroupNameByCatId } from '../index'
    import { loadAssetKindList, loadRetailerDevcGroupList } from '../retailer/asset-comn'
    //
    import shopStuffApi from '../../api/shopStuff'
    import retailerApi from '../../api/retailer';
    import assetApi from '../../api/asset'

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    export default {
        name: 'swb-stuff-appturn-voucher-info',
        desc: '耗材领用单详情',
        props: ['voucherId'],
        data: function () {
            return {
                confKey: "swb-shop-device-appturn-voucher-lowCost-info",
                resultKey: "swb-shop-device-appturn-voucher-lowCost-info",
                tableHeight: 500,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                resultColConf: null,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                bizLogList: [],
                //
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                //
                stuffAppturnVoucherInfo: {},
                shopDeviceAppturnItem: [],
                acctEnterWayMap: {},
                //
                activeName: 'device',
                selectTableDevice: true,
                selectTableDurable: false,
                exitDeviceItem: false,      // 是否包含 资产
                exitDurableItem: false,     // 是否包含 耐用
                durable: false,
                assetKindList: [],
                showQuery: true,
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.acctEnterWayMap = getEnumMap("acctEnterWay", "value2text");
            //
            this.getStuffAppturnVoucherInfo();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            //domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), null);
            //domSizeWatcher.setHrEls();

            //domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onResultConfigReady: function () {
                let self = this;
                let query_model_ctrl = self.$refs['query_model_ctrl'];
//                self.getDepartList(function (departIdList) {
//                    let data = {dataList: departIdList};
//                    let vendorUknoItem = {};
//                    vendorUknoItem["departId"] = data;
//                    query_model_ctrl.updateFields(vendorUknoItem);
//                });
                //
                let acctEnterWay = getEnumList("acctEnterWay");
                let dataList = [];
                acctEnterWay.forEach(function (item) {
                    let queryAcctEnterWay = {
                        value: item.value,
                        label: item.text
                    };
                    dataList.push(queryAcctEnterWay);
                });
                let acctEnterWayMap = {};
                acctEnterWayMap["acctEnterWay"] = {dataList: dataList};
                query_model_ctrl.updateFields(acctEnterWayMap);
                // 分类分组
                loadRetailerDevcGroupList(function (dataList) {
                    self.updateQueryModelField("devcGroupId", dataList);
                });
                // 财务类别
                loadAssetKindList(function (dataList) {
                    self.assetKindList = dataList;
                    self.updateQueryModelField("assetKindId", dataList);
                });
                //
                let vendorUknoItem = {};
                vendorUknoItem["vendorUkno"] = {
                    hidden: self.activeName == "durable"
                };
                query_model_ctrl.updateFields(vendorUknoItem);
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            //
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去
                resultTable.setQrySortRef(query_model_ctrl);
                // resultTable.setColConfRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'groupName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.catId != null) {
                            let cat = self.getGoodsCatDevcGroupName(row.catId);
                            if(cat != null) {
                                return '<span>' + cat + '</span>';
                            }
                        }
                    },
                    'imageUrl': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue != null) {
                            return '<a href="#"><img style="height: 36px;width: 36px" src="' + row.imageUrl + '"/></a>';
                        }
                    },
                    'acctEnterWay': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue != null) {
                            return '<span>' + self.acctEnterWayMap[colValue] + '</span>';
                        }
                    },
                }, /* 单元格按钮点击处理函数 */{});
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getGoodsCatDevcGroupName: function (catId) {
                return getDevcGroupNameByCatId(catId);
            },
            queryHandler(queryModel) {
                this.queryModel = queryModel;
                //
                this.pageNumber = 1;
                this.getStuffAppturnItemList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getStuffAppturnItemList();
            },
            getStuffAppturnVoucherInfo(){
                let self = this;
                let theLoad = MsgBox.loading();
                let params = {};
                params.id = self.voucherId;
                shopStuffApi.getStuffAppturnVoucherInfo(params, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.stuffAppturnVoucherInfo = result.data;
                        // 获取单项信息
                        self.getStuffAppturnItemList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getStuffAppturnItemList();
            },
            // 获取 领用单项分页列表
            getStuffAppturnItemList: function () {
                let self = this;
                //
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.voucherId = self.voucherId;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                shopStuffApi.getStuffAppturnItemList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.shopDeviceAppturnItem = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        //
                        self.renderTable(result.data.rows, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            getAssetKindList(callback){
                let self = this;
                let theLoad = MsgBox.loading();
                assetApi.getAssetKindList({}, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let assetKindList = result.data;
                        let showAssetKindList = [];
                        showAssetKindList.push({"value": null, "label": "-全部-"});
                        if(!Utils.isNoB(assetKindList) && assetKindList.length > 0) {
                            assetKindList.forEach(function (item) {
                                let queryItem = {};
                                queryItem.value = item.id;
                                queryItem.label = item.name;
                                showAssetKindList.push(queryItem);
                            });
                        }
                        callback(showAssetKindList);
                    } else {
                        Toast.show(result.message);
                    }
                });
            },
            getDepartList(callback) {
                let self = this;
                let postData = {};
                let theLoad = MsgBox.loading();
                retailerApi.getRetailerDepartList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        let departList = result.data;
                        let dataList = [];
                        dataList.push({"value": null, "label": "-全部-"});
                        if(departList != null && departList.length > 0) {
                            departList.forEach(function (item) {
                                let queryItem = {};
                                queryItem.value = item.id;
                                queryItem.label = item.name;
                                dataList.push(queryItem);
                            });
                        }
                        callback(dataList);
                    } else {
                        MsgBox.error(result.message);
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/shopStuff/StuffAppturnVoucherInfo.vue